import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import api from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementCommentsResult } from '../../model/AnnouncementCommentsResult';
import CommentGroupItem from './CommentGroupItem';
import styled from 'styled-components';
import { IGlobalState } from '../../model/IGlobalState';
import FormTextItem from '../form/FormTextItem';
import FormTextArea from '../form/FormTextArea';

interface IProps{
    combinedTicker:string
    match?: { params: {  combinedTicker:string, announcementGuid:string }};
}

const Wrapper = styled.div`
.comment-groups-container{

}

`;

    const EditAnnouncementComments: React.FC<IProps>= (props:IProps) => {
    const dispatch = useDispatch();
    const currentStock = useSelector((state: IGlobalState) => state.currentStock)
    const [ item, setItem ] = useState<AnnouncementCommentsResult>();

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        let announcementGuid;
        let combinedTicker = props.combinedTicker;
        if(props.match){
            announcementGuid = props.match.params.announcementGuid;
            combinedTicker = props.match.params.combinedTicker;
        }

        dispatch(loading(true));
        const result = await api().getAnnouncementCommentsResult(combinedTicker, announcementGuid);
        if(isMounted()){
            setItem(result)
        }
        dispatch(loading(false));


      }, []);

    // Read-only for now: these fields are shown here (not on the Config tab) but are
    // not yet saveable from this tab. Hidden on the standalone /AnnouncementComments route.
    const showSettings = !props.match && !!currentStock;

    return <div>

{ showSettings && <div className="input-group">
    <FormTextItem label="Company Logo Url"   name='companyLogoUrl' value={currentStock!.companyLogoUrl!} onChange={()=>{}} disabled={true} helperText="Used by email marketing. do not use SVG"/>
    <FormTextArea label="Announcement Comment Template" placeholder='Paste template here' rows={10} name="announcementCommentTemplate" value={currentStock!.announcementCommentTemplate||''} onChange={()=>{}} disabled={true} className='config__announcement-comment-template' />
</div>}

{ item && <Wrapper>
    <p>Comments are relevant for the <a href="https://web.investi.com.au/interactive-announcements/" target='_blank' rel="noreferrer">interactive announcements</a> widget</p>
<p>Total number of comments for {item.combinedTicker}: {item.commentGroups.length} </p>
<div className='comment-groups-container'>
{  item.commentGroups.map((x,i)=> <CommentGroupItem key={i} commentGroup={x}/>)}
</div>

</Wrapper>}

    </div>
}

export default EditAnnouncementComments
